import { useRoutes } from "react-router-dom";
import DeviceType from "./DeviceType/Component/deviceType";
import QualityProcedureBuilder from "./QualityChecklistConfiguration/Component/qualityProcedureBuilder";
import QualityProcedureBuilderForm from "./QualityChecklistConfiguration/Component/qualityProcedureBuilderForm";

const QualityConfigurationIndex = () => {
  const router = useRoutes([
    {
      index: true,
      element: <DeviceType />,
    },
    {
      path: "procedure-builder/*",
      children: [
        {
          index: true,
          element: <QualityProcedureBuilder />,
        },
        {
          path: "add",
          element: <QualityProcedureBuilderForm mode="add" />,
        },
        {
          path: "edit/:uuid",
          element: <QualityProcedureBuilderForm mode="edit" />,
        },
        {
          path: "view/:uuid",
          element: <QualityProcedureBuilderForm mode="view" />,
        },
      ],
    },
  ]);
  return <div>{router}</div>;
};
export default QualityConfigurationIndex;
